@if (marketsGroup.marketsAvailable) {
    <accordion
        [isExpanded]="isExpanded"
        [headerClass]="'secondary-header'"
        [isChevronToLeft]="true"
        [memoryId]="memoryId"
        (function)="changeAccordionState($event, marketsGroup)"
        [memoryLocation]="memoryLocation"
        [accordionTitle]="marketsGroup.name">
        <right-side>
            @if (!marketsGroup.drilldownTagNames && marketsGroup.cashoutAvail && !bybTabAvb) {
                <cashout-label></cashout-label>
            }
            <!-- Promotional signposting -->
            @if (marketsGroup.drilldownTagNames) {
                <promotion-icon
                    [type]="'market'"
                    [mode]="'big'"
                    [cashoutAvailable]="marketsGroup.cashoutAvail"
                    [display]="marketsGroup.drilldownTagNames"
                    [bwinId]="marketsGroup.bwinId"
                    [eventId]="eventEntity.id"
                    [event]="eventEntity"
                    [isEventStartedOrLive]="eventEntity.eventIsLive"
                    [accordionTitle]="marketsGroup.name"
                    [sport]="'sport'"
                    [bybTabAvb]="bybTabAvb"
                    [isEDPPage]="true"
                    data-crlat="promotionIcons">
                </promotion-icon>
            }
        </right-side>
        @if (isExpanded) {
            <accordion-body>
                @if (isDesktop && isMarketwithPB && !marketsGroup.isLoaded) {
                    <div [ngClass]="marketsGroup.isLoaded ? 'invisible' : 'visible'" class="loading-v3" data-crlat="flashing.loader">
                        <div class="dot-flashing"></div>
                    </div>
                }
                <div [ngClass]="marketsGroup.isLoaded ? 'visible' : 'invisible'">
                    @if (isFootball && isOptaProviderPresent && marketsGroup.marketOptaLink && isOptaAvailable) {
                        <scoreboard-link [market]="marketsGroup" [event]="eventEntity"> </scoreboard-link>
                    }
                    @if (marketsGroup.periods) {
                        <switchers data-crlat="switchers" [type]="'links'" [filter]="periodIndex" [switchers]="switchers"> </switchers>
                    }
                    @if (!isMarketHeader) {
                        <div class="container-inner-content">
                            @for (market of selectedMarkets(periodIndex); track trackByFn(i); let i = $index) {
                                <div data-crlat="containerInnerContent">
                                    <!-- Market Row -->
                                    @if (isMarketRow) {
                                        <div class="row row-center row-no-gutter row-col-last row-pad is-horizontal">
                                            @for (outcome of selectedOutcomes(market.outcomes); track trackByFn(i); let i = $index) {
                                                <div class="col-xs col-bordered" data-crlat="oddsCard">
                                                    <div class="col-inner col-vertical">
                                                        <strong class="col-name" data-crlat="outcome.name" [textContent]="outcome.name"></strong>
                                                        <price-odds-button
                                                            [event]="eventEntity"
                                                            [market]="market"
                                                            [outcome]="outcome"
                                                            class="one-row-btn"></price-odds-button>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                    <!-- Market Card -->
                                    @if (isMarketCard) {
                                        <div>
                                            @for (outcome of selectedOutcomes(market.outcomes); track trackByFn(i); let i = $index) {
                                                <div class="odds-card" data-crlat="oddsCard">
                                                    <div class="odds-content">
                                                        <div class="odds-left no-wrap" data-crlat="oddsLeft">
                                                            <strong class="odds-name">
                                                                <span [textContent]="outcome.alphabetName" data-crlat="outcome.alphabetName"></span>
                                                                <span [textContent]="outcome.numbersName" data-crlat="outcome.numbersName"></span>
                                                            </strong>
                                                        </div>
                                                        <div class="odds-right" data-crlat="oddsRight">
                                                            <price-odds-button
                                                                data-crlat="marketsGroup.eventEntity"
                                                                [event]="eventEntity"
                                                                [market]="market"
                                                                [outcome]="outcome"></price-odds-button>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                    <!-- Market Card with Header-->
                    @if (isMarketHeader && !isMarketwithPB) {
                        <div class="container-inner-content" data-crlat="containerInnerContent.table">
                            @if (marketsLength() && !showHeader() && !isPlayerCaredMarket) {
                                <div class="odds-card-header">
                                    <div class="odds-left" data-crlat="oddsLeft">
                                        @if (isMarketHeader) {
                                            <span class="odds-header-title" [textContent]="marketsGroup.headerLabel" data-crlat="oddsHeader"></span>
                                        }
                                    </div>
                                    <div class="odds-right" data-crlat="oddsRight">
                                        @for (header of marketsGroup.header; track header) {
                                            <span class="odds-header-col" [textContent]="header.name" data-crlat="oddsHeader"></span>
                                        }
                                    </div>
                                </div>
                            }
                            @for (market of selectedMarkets(periodIndex); track market) {
                                <div class="odds-card" data-crlat="oddsCard">
                                    <div class="odds-content">
                                        <div class="odds-left" data-crlat="oddsLeft">
                                            <strong class="odds-name" data-crlat="oddsNames" [textContent]="market.name"></strong>
                                        </div>
                                        <div class="odds-right" data-crlat="oddsRight">
                                            <div class="odds-btn-content">
                                                @for (
                                                    outcome of getMarketOutcomes(market, periodIndex);
                                                    track trackById(i, outcome);
                                                    let i = $index
                                                ) {
                                                    <div class="odds-btn-wrapper">
                                                        @if (!outcome.fakeOutcome) {
                                                            <price-odds-button
                                                                [event]="eventEntity"
                                                                [market]="market"
                                                                [isPb]="isPlayerCaredMarket"
                                                                [outcome]="outcome">
                                                            </price-odds-button>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            @if (marketNoGoal) {
                                <div class="odds-card" data-crlat="oddsCard">
                                    <div class="odds-content">
                                        <div class="odds-left" data-crlat="oddsLeft">
                                            <strong class="odds-name" data-crlat="oddsNames" [textContent]="marketNoGoal.name"></strong>
                                        </div>
                                        <div class="odds-right" data-crlat="oddsRight">
                                            <div class="odds-btn-content">
                                                @for (outcome of marketNoGoal.outcomes; track outcome) {
                                                    <div class="odds-btn-wrapper">
                                                        @if (!outcome.fakeOutcome) {
                                                            <price-odds-button
                                                                [event]="eventEntity"
                                                                [market]="marketNoGoal.marketInfo"
                                                                [outcome]="outcome">
                                                            </price-odds-button>
                                                        }
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    @if (isMarketwithPB && reloadPB) {
                        <player-bets
                            [marketsGroup]="marketsGroup"
                            [eventEntity]="eventEntity"
                            [periodIndex]="periodIndex"
                            [limitCount]="limitCount"
                            (isLoaded)="playerbetsLoaded($event)">
                        </player-bets>
                    }

                    @if (showLessButton) {
                        <show-all-button data-crlat="showAllButton" (click)="toggleShow()" [allShown]="isAllShow"> </show-all-button>
                    }
                    @if (!marketsLength()) {
                        <no-events></no-events>
                    }
                </div>
            </accordion-body>
        }
    </accordion>
}
